import axiosPrivate from "../../../api/axiosPrivate";
import {
  GET_ACTION_ACTIVITIES,
  GET_AGENT_REPORT,
  GET_CLAIM_REPORT,
  GET_CUSTOMER_OVERVIEW,
  GET_CUSTOMER_PAYMENT,
  GET_CUSTOMER_POLICY_EXPIRY,
  GET_CUSTOMER_POLICY_INFO,
  GET_INDIVIDUAL_SAVINGS_REPORT,
  GET_OVERVIEW_DATA,
  GET_RENEWED_POLICY,
  GET_SAVINGS_ACCOUNT_REPORT,
  GET_SAVINGS_CLAIM_REPORT,
  GET_SAVINGS_CONTRIBUTION_REPORT,
  GET_TRIAL_BALANCE,
  GET_USER_ACTIVITIES,
} from "../../../api/constant";

const getActions = async () => {
  const response = await axiosPrivate.get(`${GET_ACTION_ACTIVITIES}`);
  return response.data;
};
const getUserActivities = async ({
  start_date,
  end_date,
  office_id,
  staff_id,
  action,
  pageNumber,
}) => {
  const response = await axiosPrivate.get(
    `${GET_USER_ACTIVITIES}?startDate=${start_date}&endDate=${end_date}&office_id=${office_id}&user_id=${staff_id}&action=${action}&page=${pageNumber}`
  );
  return response.data;
};
const getCustomerOverview = async ({
  start_date,
  end_date,
  office_id,
  staff_id,
  status,
}) => {
  const response = await axiosPrivate.get(
    `${GET_CUSTOMER_OVERVIEW}?start_date=${start_date}&end_date=${end_date}&office_id=${office_id}&agent_id=${staff_id}&status=${status}`
  );
  if (response.data.key) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const overviewData = await getOverviewData(response.data.key);
        resolve({ overviewData });
      }, 4000); // 4000 milliseconds = 4 seconds
    });
  } else {
    return response.data;
  }
  // return response.data;
};
const getCustomerPayment = async ({
  start_date,
  end_date,
  office_id,
  staff_id,
  customer_id,
  policy_id,
}) => {
  const response = await axiosPrivate.get(
    `${GET_CUSTOMER_PAYMENT}?start_date=${start_date}&end_date=${end_date}&office_id=${office_id}&agent_id=${staff_id}&customer_id=${customer_id}&policy_app_number=${policy_id}&`
  );
  if (response.data.key) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const overviewData = await getOverviewData(response.data.key);
        resolve({ overviewData });
      }, 4000); // 4000 milliseconds = 4 seconds
    });
  } else {
    return response.data;
  }
  // return response.data;
};
const getCustomerPolicyInfo = async ({
  start_date,
  end_date,
  office_id,
  staff_id,
  policyStatus_id,
  policy_id,
}) => {
  const response = await axiosPrivate.get(
    `${GET_CUSTOMER_POLICY_INFO}?start_date=${start_date}&end_date=${end_date}&office_id=${office_id}&agent_id=${staff_id}&policy_app_number=${policy_id}&status=${policyStatus_id}`
  );
  if (response.data.key) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const overviewData = await getOverviewData(response.data.key);
        resolve({ overviewData });
      }, 4000); // 4000 milliseconds = 4 seconds
    });
  } else {
    return response.data;
  }
  // return response.data;
};
const getAgentReport = async ({
  start_date,
  end_date,
  office_id,
  staff_id,
  policyStatus_id,
  policy_id,
}) => {
  const response = await axiosPrivate.get(
    `${GET_AGENT_REPORT}?start_date=${start_date}&end_date=${end_date}&office_id=${office_id}&agent_id=${staff_id}&policy_status=${policyStatus_id}`
  );
  if (response.data.key) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const overviewData = await getOverviewData(response.data.key);
        resolve({ overviewData });
      }, 4000); // 4000 milliseconds = 4 seconds
    });
  } else {
    return response.data;
  }
  // return response.data;
};
const getCustomerPolicyExpiry = async ({
  start_date,
  end_date,
  office_id,
  staff_id,
  policy_id,
}) => {
  const response = await axiosPrivate.get(
    `${GET_CUSTOMER_POLICY_EXPIRY}?start_date=${start_date}&end_date=${end_date}&office_id=${office_id}&agent_id=${staff_id}&policy_app_number=${policy_id}`
  );
  if (response.data.key) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const overviewData = await getOverviewData(response.data.key);
        resolve({ overviewData });
      }, 4000); // 4000 milliseconds = 4 seconds
    });
  } else {
    return response.data;
  }
};
const getClaimReport = async ({
  start_date,
  end_date,
  office_id,
  staff_id,
  policy_id,
  claim_status,
  customer_id,
}) => {
  const response = await axiosPrivate.get(
    `${GET_CLAIM_REPORT}?start_date=${start_date}&end_date=${end_date}&office_id=${office_id}&agent_id=${staff_id}&policy_id=${policy_id}&claim_status=${claim_status}&customer_id=${customer_id}`
  );
  if (response.data.key) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const overviewData = await getOverviewData(response.data.key);
        resolve({ overviewData });
      }, 4000); // 4000 milliseconds = 4 seconds
    });
  } else {
    return response.data;
  }
};
const getRenewedPolicy = async ({
  start_date,
  end_date,
  office_id,
  staff_id,
  policy_id,
}) => {
  const response = await axiosPrivate.get(
    `${GET_RENEWED_POLICY}?start_date=${start_date}&end_date=${end_date}&office_id=${office_id}&staff_id=${staff_id}&policy_id=${policy_id}`
  );
  if (response.data.key) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const overviewData = await getOverviewData(response.data.key);
        resolve({ overviewData });
      }, 4000); // 4000 milliseconds = 4 seconds
    });
  } else {
    return response.data;
  }
};
const getTrialBalance = async ({ start_date, end_date, office_id }) => {
  const response = await axiosPrivate.get(
    `${GET_TRIAL_BALANCE}?start_date=${start_date}&end_date=${end_date}&office_id=${office_id}`
  );
  if (response.data.key) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const overviewData = await getOverviewData(response.data.key);
        resolve({ overviewData });
      }, 4000); // 4000 milliseconds = 4 seconds
    });
  } else {
    return response.data;
  }
};


const getIndividualSavings = async ({
  start_date,
  end_date,
  office_id,
  staff_id,
  customer_id,
  savings_policy_id
}) => {
  const response = await axiosPrivate.get(
    `${GET_INDIVIDUAL_SAVINGS_REPORT}?start_date=${start_date}&end_date=${end_date}&office_id=${office_id}&agent_id=${staff_id}&customer_id=${customer_id}&savings_policy_id=${savings_policy_id}`
  );
  if (response.data.key) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const overviewData = await getOverviewData(response.data.key);
        resolve({ overviewData });
      }, 4000); // 4000 milliseconds = 4 seconds
    });
  } else {
    return response.data;
  }
};

const getSavingsAccountReport = async ({
  start_date,
  end_date,
  office_id,
  staff_id,
  savings_policy_id
}) => {
  const response = await axiosPrivate.get(
    `${GET_SAVINGS_ACCOUNT_REPORT}?start_date=${start_date}&end_date=${end_date}&office_id=${office_id}&agent_id=${staff_id}&savings_policy_id=${savings_policy_id}`
  );
  if (response.data.key) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const overviewData = await getOverviewData(response.data.key);
        resolve({ overviewData });
      }, 4000); // 4000 milliseconds = 4 seconds
    });
  } else {
    return response.data;
  }
};

const getSavingsClaimReport = async ({
  start_date,
  end_date,
  office_id,
  staff_id,
  savings_policy_id,
  customer_id,
  claim_category,
  claim_type
}) => {
  const response = await axiosPrivate.get(
    `${GET_SAVINGS_CLAIM_REPORT}?start_date=${start_date}&end_date=${end_date}&office_id=${office_id}&customer_id=${customer_id}&agent_id=${staff_id}&savings_policy_id=${savings_policy_id}&claim_category=${claim_category}&claim_type=${claim_type}`
  );
  if (response.data.key) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const overviewData = await getOverviewData(response.data.key);
        resolve({ overviewData });
      }, 4000); // 4000 milliseconds = 4 seconds
    });
  } else {
    return response.data;
  }
};

const getSavingsContributionReport = async ({
  start_date,
  end_date,
  office_id,
  staff_id,
  savings_policy_id,
  customer_id,
}) => {
  const response = await axiosPrivate.get(
    `${GET_SAVINGS_CONTRIBUTION_REPORT}?start_date=${start_date}&end_date=${end_date}&office_id=${office_id}&customer_id=${customer_id}&agent_id=${staff_id}&savings_policy_id=${savings_policy_id}`
  );
  if (response.data.key) {
    return new Promise((resolve) => {
      setTimeout(async () => {
        const overviewData = await getOverviewData(response.data.key);
        resolve({ overviewData });
      }, 4000); // 4000 milliseconds = 4 seconds
    });
  } else {
    return response.data;
  }
};

const getOverviewData = async (key) => {
  const response = await axiosPrivate.get(`${GET_OVERVIEW_DATA}?key=${key}`);
  return response.data;
};

const reportService = {
  getActions,
  getUserActivities,
  getCustomerOverview,
  getOverviewData,
  getCustomerPayment,
  getCustomerPolicyInfo,
  getCustomerPolicyExpiry,
  getAgentReport,
  getClaimReport,
  getTrialBalance,
  getRenewedPolicy,
  getIndividualSavings,
  getSavingsAccountReport,
  getSavingsClaimReport,
  getSavingsContributionReport,
};

export default reportService;
